'use strict';

module.exports = /*@ngInject*/
function profileService(
    $q,
    $rootScope,
    EventsConfig,
    ProfileHTTPService
) {
    var service = {
        /**
         * Get a default profile model
         * @return {Object} The default profile model
         */
        getDefaultModel: function() {
            return {
                mobileUserName: '',
                profile: null,
                userName: ''
            };
        },

        /**
         * Get the profile's user name for the mobile website
         * @return {String} The mobile user name
         */
        getMobileUserName: function() {
            return model.mobileUserName;
        },

        /**
         * Get the profile model
         * @return {Object} The profile model
         */
        getModel: function() {
            return model;
        },

        /**
         * Get the Profile HTTP Response
         * @return {Object} The Profile HTTP Response
         */
        getProfileRes: function() {
            return model.profile;
        },

        /**
         * Get the profile's user name
         * @return {String} The profile's user name
         */
        getUserName: function() {
            return model.userName;
        },

        /**
         * Initialize the profile model
         * @return {Object} $q promise to be fulfilled by the profile model
         */
        init: function() {
            var deferred = $q.defer();

            if (service.isInitialized()) {
                deferred.resolve(model);
                return deferred.promise;
            }

            return ProfileHTTPService.getPartialProfile()
                .then(function onPartialProfileRes(res) {
                    var profile = res.customer;

                    service.setMobileUserName(profile);
                    service.setProfileRes(profile);
                    service.setUserName(profile);

                    return model;
                });
        },

        /**
         * Is the Profile Service initialized?
         * @return {Boolean} True, if the Profile Service is initialized; false, otherwise.
         */
        isInitialized: function() {
            return service.getProfileRes() !== null;
        },

        /**
         * Is the user logged in?
         * @param {Object} profile Profile HTTP Response
         * @return {Boolean} True, if logged in; false, otherwise.
         */
        isLoggedIn: function(profile) {
            return profile.securityStatus >= 3 && profile.guest === false;
        },

        /**
         * Is the user a loyalty customer?
         * @param {Object} profile Profile HTTP Response
         * @return {Boolean} True, if the user is a loyalty customer; false, otherwise.
         */
        isLoyaltyCustomer: function(profile) {
            return profile.securityStatus >= 3 && profile.loyaltyId !== null;
        },

        /**
         * Async proxy for when the user is logged in.
         * @return {Object} $q promise to be fulfilled on login
         *                  and rejected if user is not logged in
         */
        onLogin: function() {
            return service.init()
                .then(function onInit(model) {
                    if (service.isLoggedIn(model.profile)) {
                        return model;
                    } else {
                        return $q.reject();
                    }
                });
        },

        /**
         * Async proxy for when the user is logged in.
         * @return {Object} $q promise to be fulfilled when user is
         *                  a loyalty customer and rejected if user is not
         */
        onLoyaltyCustomer: function() {
            return service.init()
                .then(function onInit(model) {
                    if (service.isLoyaltyCustomer(model.profile)) {
                        return model;
                    } else {
                        return $q.reject();
                    }
                });
        },

        /**
         * Reset the model
         * @return {Object} The profile model
         */
        resetModel: function() {
            model = service.getDefaultModel();
            return model;
        },

        /**
         * Set the mobile user name
         * @param {Object} profile Profile HTTP Response
         */
        setMobileUserName: function(profile) {
            var index;

            if (profile.firstName) {
                model.mobileUserName = profile.firstName;
            } else if (profile.login !== null) {
                index = profile.login.indexOf('@');
                model.mobileUserName = index > 0 ? profile.login.substring(0, index) : profile.login;
            }
        },

        /**
         * Set the Profile HTTP Response
         * @param {Object} profile Profile HTTP Response
         */
        setProfileRes: function(profile) {
            model.profile = profile;
        },

        /**
         * Set the user name
         * @param {Object} profile Profile HTTP Response
         */
        setUserName: function(profile) {
            if (profile.firstName) {
                model.userName = profile.firstName + '\'s Account';
            } else {
                model.userName = 'My Account';
            }
        }
    };

    // create the model
    // TODO implement ONE anthro app to rule them all
    // to prevent having to globalize app state
    var model = window.model = window.model || service.getDefaultModel();

    // subscribe the logout event and reset model
    $rootScope.$on(EventsConfig.user.logout, service.resetModel);

    return service;
};
